import gql from 'graphql-tag';

export const USER_FIELDS = gql`
  fragment UserFields on User {
    id
    firstName
    lastName
    displayName
    email
    language
    intercomIdentityVerificationHash
  }
`;

export const CUSTOMER_FIELDS = gql`
  fragment CustomerFields on Customer {
    id
    cardBrand
    cardLastFour
    email
    address1
    city
    countryCode
    postCode
    vatNumber
  }
`;

export const SUBSCRIPTION_FIELDS = gql`
  fragment SubscriptionFields on Subscription {
    quantity
    endsAt
    cancelsAt
    trialEndsAt
    billingCycleAnchor
  }
`;

export const PRODUCT_FIELDS = gql`
  fragment ProductFields on Product {
    id
    name
    isActive
    isFree
    isBridge
  }
`;

export const PLAN_FIELDS = gql`
  fragment PlanFields on Plan {
    id
    productId
    price
    currency
    period
  }
`;
